__turbopack_context__.v({
  "manaSymbol": "_4Xrw7W_manaSymbol",
  "medium": "_4Xrw7W_medium",
  "small": "_4Xrw7W_small",
});
